import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { Rangos } from "./componentes/rangos";
import { TarifaValores } from "./componentes/valores/index";
import { TarifaGlobalesComponent } from "./componentes/globales";
import { MatrizTarifaRangoEspecialList } from "./componentes/rangosespeciales/list";
type Entity = models.MatrizTarifa;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}



/**
* Componente para editar un Entity
*/
export class MatrizTarifaFormNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {};
    }

    render() {
        const { value, onGuardar, nuevo, onChange } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const ValoresPaquete = getField(TarifaValores);
        const TarifaGlobales = getField(TarifaGlobalesComponent);
        const Especiales = getField(MatrizTarifaRangoEspecialList);
        const rangos = <Rangos value={value} onChange={onChange} />; 0
        const importesPaquete = <ValoresPaquete field="MatrizTarifaCeldas" pesos={value.MatrizTarifaPesos} distancias={value.MatrizTarifaDistancias} />
        const globales = <TarifaGlobales field="Globales" />
        const especiales = <Especiales field="RangosEspeciales" />
        return (
            <div>
                <kea.Title titulo="Editar matriz de tarifas" onRegresar={() => history.go("/catalogos/MatrizTarifa")} />
                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.Tab items={[
                            { title: "Distancias y pesos", iconClass: fa("map-o"), body: rangos },
                            { title: "Tarifas por paquete", iconClass: fa("cubes"), body: importesPaquete },
                            { title: "Tarifas globales", iconClass: fa("globe"), body: globales },
                            { title: "Rangos especiales", iconClass: fa("list-ol"), body: especiales },
                        ]} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}

export const MatrizTarifaForm = componentToRx(MatrizTarifaFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/edit/form.tsx